// Chat
export const CHAT_TO = "CHAT_TO";

// User
export const AUTH_USER = "AUTH_USER";
export const MY_VOCATION = "MY_VOCATION";
export const MY_U_INTEREST = "MY_U_INTEREST";
